import {ActionLink} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const LanguageLaboratoryLink = (context: NavigationContext): ActionLink => ({
    type: 'actionLink',
    label: 'navigation.language_laboratory',
    link: context.languageLaboratory.link,
    icon: 'navigation-link__list-item',
    action: context.languageLaboratory.action,
});